import { Observable, type FetchFunction } from 'relay-runtime';

import { trackInFlightIfAllowed, shouldBlockRequest, markSSRTestQueryFired } from './ssrGuards.ts';

// Analogous to Apollo SSRTestLink - counts queries fired for E2E test parity
export const createSSRTestFetch = (baseFetch: FetchFunction): FetchFunction => {
	return (request, variables, cacheConfig, uploadables) => {
		markSSRTestQueryFired(request.name);
		return baseFetch(request, variables, cacheConfig, uploadables);
	};
};

// Analogous to Apollo SSRLink - applies SSR guards and blocking logic
export const createSSRFetch = (baseFetch: FetchFunction): FetchFunction => {
	return (request, variables, cacheConfig, uploadables) => {
		// Track in-flight queries only when not globally skipping
		trackInFlightIfAllowed({ operationName: request.name, variables });

		// Block after SSR if required, unless this op was already in-flight or is a preload
		if (
			shouldBlockRequest({
				operationName: request.name,
				variables,
				metadata: cacheConfig?.metadata,
				operationKind: request.operationKind,
			})
		) {
			return Observable.create(() => {
				// Don't call observer.complete() - keep Suspense in loading state
				// This matches Apollo's behavior where blocked queries stay in loading
				return () => {};
			});
		}

		// Delegate to base fetch
		return baseFetch(request, variables, cacheConfig, uploadables);
	};
};
